import api from "PFCore/api";
import { DEFAULT_API_VERSION } from "PFCore/api/utils";
import { Id, PureCustomValueCamelCased } from "PFTypes";

export type AutocompleteCustomValuesParams = {
  term?: string;
  type?: string | string[];
  global?: boolean;
  value?: string[];
  limit?: number;
  connectedOptions?: boolean;
  customValueIds?: Id[];
};

export type AutocompleteCustomValuesResponse = PureCustomValueCamelCased[];

export const fetchAutocompleteCustomValues = (
  params: AutocompleteCustomValuesParams,
  // apiVersion 1 is deprecated — kept only for callers not yet migrated off it.
  // v1 forces `global: false` (org-scoped results only); v2 respects the `global` param as passed.
  { apiVersion }: { apiVersion: 1 | 2 } = { apiVersion: DEFAULT_API_VERSION }
): Promise<AutocompleteCustomValuesResponse> =>
  api({
    url: "autocomplete/custom_values",
    apiVersion,
    params: {
      ...(apiVersion === 1 && { global: false }),
      ...params
    }
  });

export const fetchAutocompleteSkills = (
  params: Omit<AutocompleteCustomValuesParams, "type">,
  options?: { apiVersion: 1 | 2 }
) => fetchAutocompleteCustomValues({ type: "skills", ...params }, options);
